import Home from './screens/home';

export default function App() {
  return <Home />;
}
